import { Util } from '@otas/utils/custom-components/panchang-calendar/kollavarsham/util';

const pad = function (num, size) {
    const s = `000000000${num}`;
    return s.substr(s.length - size);
};

const masaNames = {
    0: { saka: 'Caitra    ', saura: 'Mesa      ', enMalayalam: 'Chingam   ', mlMalayalam: 'ചിങ്ങം' },
    1: { saka: 'Vaisakha  ', saura: 'Vrsa      ', enMalayalam: 'Kanni     ', mlMalayalam: 'കന്നി' },
    2: { saka: 'Jyaistha  ', saura: 'Mithuna   ', enMalayalam: 'Thulam    ', mlMalayalam: 'തുലാം' },
    3: { saka: 'Asadha    ', saura: 'Karkata   ', enMalayalam: 'Vrischikam', mlMalayalam: 'വൃശ്ചികം' },
    4: { saka: 'Sravana   ', saura: 'Simha     ', enMalayalam: 'Dhanu     ', mlMalayalam: 'ധനു' },
    5: { saka: 'Bhadrapada', saura: 'Kanya     ', enMalayalam: 'Makaram   ', mlMalayalam: 'മകരം' },
    6: { saka: 'Asvina    ', saura: 'Tula      ', enMalayalam: 'Kumbham   ', mlMalayalam: 'കുംഭം' },
    7: { saka: 'Karttika  ', saura: 'Vrscika   ', enMalayalam: 'Meenam    ', mlMalayalam: 'മീനം' },
    8: { saka: 'Margasirsa', saura: 'Dhanus    ', enMalayalam: 'Medam     ', mlMalayalam: 'മേടം' },
    9: { saka: 'Pausa     ', saura: 'Makara    ', enMalayalam: 'Idavam    ', mlMalayalam: 'ഇടവം' },
    10: { saka: 'Magha     ', saura: 'Kumbha    ', enMalayalam: 'Mithunam  ', mlMalayalam: 'മിഥുനം' },
    11: { saka: 'Phalguna  ', saura: 'Mina      ', enMalayalam: 'Karkitakam', mlMalayalam: 'കർക്കടകം' }
};


export class BaseDate {
    gregorianDate = null;
    julianDay = null;
    ahargana = null;
    sauraMasa = null;
    sauraDivasa = null;
    _naksatra = null;
    year = 0; month = 0; date = 0;
    constructor(year = 0, month = 0, date = 0) {
        // eslint-disable-line no-underscore-dangle
        this.date = date;
        this.month = month;
        this.year = year;
    }
    static getMasaName(masaNumber) {
        return masaNames[masaNumber];
    }
    get naksatra() {
        return this._naksatra || {}; // eslint-disable-line no-underscore-dangle
    }

    set naksatra(val) {
        this._naksatra = val; // eslint-disable-line no-underscore-dangle
    }

    get sauraMasaName() {
        return BaseDate.getMasaName(this.sauraMasa).saura;
    }


    get weekdayName() {
        return Util.julianDayToWeekday(this.julianDay).en;
    }

    get mlWeekdayName() {
        return Util.julianDayToWeekday(this.julianDay).ml;
    }

    toString() {
        return `${pad(this.year, 4)} ${pad(this.month, 2)} ${pad(this.date, 2)}`;
    }



}

